module.exports = __webpack_public_path__ + "static/media/group_special_gochi_kid_blank_logo.c0fe3170.png";